/** Libellés Source d’un contact projet (alignés backend `addSourceLabels`). */
export const U3121_PROJECT_CONTACT_SOURCE_PROJECT = {
  source: 'project' as const,
  sourceLabelFr: 'Projet',
  sourceLabelEn: 'Project',
};

export type U3121ProjectContactValidationInput = {
  contactName?: string | null;
  contactType?: { id?: string | null } | null;
} | null | undefined;

/**
 * Erreurs de validation UI du dialogue Contact projet (requis : nom + type).
 * Clé `contactType.id` : `U2000AutoCompleteInput` affiche l’erreur sur `fieldName + ".id"`.
 */
export function u3121ProjectContactValidationErrors(
  data: U3121ProjectContactValidationInput,
  messages: { nameRequired: string; typeRequired: string },
): Record<string, string> {
  const result: Record<string, string> = {};
  if (!data?.contactName?.trim()) result.contactName = messages.nameRequired;
  if (!data?.contactType?.id) result['contactType.id'] = messages.typeRequired;
  return result;
}
